module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('page-outline', {
    attrs: {
      "title": _vm.$t('businessDocuments.form_document_request_title'),
      "icon": "icon-sent",
      "returnUrl": "/home/"
    }
  }, [_c('template', {
    slot: "pageContent"
  }, [_c('form-accordion', {
    attrs: {
      "title": _vm.$t('attachments.file')
    }
  }, [_c('b-row', [_c('b-col', {
    staticClass: "form-group",
    attrs: {
      "sm": "6"
    }
  }, [_c('form-write-group-label-input', {
    attrs: {
      "isMandatory": "",
      "idLabel": _vm.$t('businessDocuments.document_type'),
      "inputType": 'listeSelect',
      "mandatoryErrorIndicator": _vm.fileTypeSelectedError
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fileTypeSelected),
      expression: "fileTypeSelected"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "sel2",
      "readonly": ""
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.fileTypeSelected = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.checkFileType]
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('businessDocuments.slct_doct_type')))]), _vm._v(" "), _vm._l((_vm.fileTypeList), function(fileType) {
    return _c('option', {
      key: fileType.fileTypeValue,
      style: (fileType.disabled ? 'font-style:italic;' : ''),
      attrs: {
        "disabled": fileType.disabled
      },
      domProps: {
        "value": fileType.fileTypeValue
      }
    }, [_vm._v("\n                " + _vm._s(_vm.$t(fileType.fileTypeLabel)) + "\n              ")])
  })], 2)])], 1), _vm._v(" "), (_vm.fileTypeSelected == 'ACTE') ? _c('b-col', {
    staticClass: "form-group",
    attrs: {
      "sm": "6"
    }
  }, [_c('form-write-group-label-input', {
    attrs: {
      "isMandatory": "",
      "idLabel": _vm.$t('businessDocuments.serialize.ACTE.SIREN'),
      "placeholderValue": _vm.$t('businessDocuments.serialize.ACTE.SIREN'),
      "mandatoryErrorIndicator": _vm.requestNameError,
      "regexpErrorIndicator": _vm.requestNameRegexpError
    },
    model: {
      value: (_vm.requestName),
      callback: function($$v) {
        _vm.requestName = $$v
      },
      expression: "requestName"
    }
  })], 1) : _c('b-col', {
    staticClass: "form-group",
    attrs: {
      "sm": "6"
    }
  }, [_c('form-write-group-label-input', {
    attrs: {
      "isMandatory": "",
      "idLabel": _vm.$t('businessDocuments.request_name'),
      "placeholderValue": _vm.$t('businessDocuments.request_name'),
      "mandatoryErrorIndicator": _vm.requestNameError
    },
    model: {
      value: (_vm.requestName),
      callback: function($$v) {
        _vm.requestName = $$v
      },
      expression: "requestName"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('form-accordion', {
    attrs: {
      "title": _vm.$t('contacts.recipient_label')
    }
  }, [(_vm.fileTypeSelected == 'ACTE') ? _c('b-form-group', [_c('b-form-radio', {
    staticClass: "creationFormBtnRadio",
    attrs: {
      "name": "radios-locationTypeFile",
      "value": "1"
    },
    model: {
      value: (_vm.contactType),
      callback: function($$v) {
        _vm.contactType = $$v
      },
      expression: "contactType"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('common.contact_label')) + "\n        ")]), _vm._v("  \n        "), _c('b-form-radio', {
    staticClass: "creationFormBtnRadio",
    staticStyle: {
      "margin-left": "35px"
    },
    attrs: {
      "name": "radios-locationTypeFile",
      "value": "2"
    },
    on: {
      "change": function($event) {
        _vm.getSharedFolders(_vm.$engine.user.get().identifier)
      }
    },
    model: {
      value: (_vm.contactType),
      callback: function($$v) {
        _vm.contactType = $$v
      },
      expression: "contactType"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('common.institut_label')) + "\n        ")])], 1) : _vm._e(), _vm._v(" "), (_vm.contactType === '1') ? _c('b-row', [_c('b-col', {
    staticClass: "form-group",
    attrs: {
      "sm": "6"
    }
  }, [_c('form-dropdown-label-input', {
    attrs: {
      "isMandatory": "",
      "idLabel": _vm.$t('common.nme'),
      "placeholderValue": _vm.$t('common.recipient_name'),
      "mandatoryErrorIndicator": _vm.recipientNameError,
      "valueKey": "name",
      "subTextKey": "identifier",
      "objectKey": "id"
    },
    model: {
      value: (_vm.selectedContact),
      callback: function($$v) {
        _vm.selectedContact = $$v
      },
      expression: "selectedContact"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    staticClass: "form-group",
    attrs: {
      "sm": "6"
    }
  }, [_c('form-write-group-label-input', {
    attrs: {
      "isMandatory": "",
      "idLabel": _vm.$t('common.idtfr'),
      "placeholderValue": _vm.$t('common.recipient_email'),
      "mandatoryErrorIndicator": _vm.recipientEmailError,
      "regexpErrorIndicator": _vm.recipientEmailRegexpError
    },
    model: {
      value: (_vm.recipientEmail),
      callback: function($$v) {
        _vm.recipientEmail = $$v
      },
      expression: "recipientEmail"
    }
  })], 1)], 1) : _vm._e()], 1), _vm._v(" "), (_vm.sharedFoldersConfig) ? _c('hr') : _vm._e(), _vm._v(" "), (_vm.sharedFoldersConfig) ? _c('form-accordion', {
    attrs: {
      "title": _vm.$t('businessDocuments.shared_folders')
    }
  }, [_c('b-form-group', [_c('b-row', [_c('b-col', {
    staticClass: "form-group",
    attrs: {
      "sm": "6"
    }
  }, [_c('b-form-radio', {
    staticClass: "creationFormBtnRadio",
    attrs: {
      "name": "radios-sharedFolderType",
      "value": "1"
    },
    model: {
      value: (_vm.sharedFolderType),
      callback: function($$v) {
        _vm.sharedFolderType = $$v
      },
      expression: "sharedFolderType"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('businessDocuments.slct_sdr')) + "\n            ")])], 1), _vm._v(" "), _c('b-col', {
    staticClass: "form-group",
    attrs: {
      "sm": "6"
    }
  }, [_c('form-write-group-label-input', {
    attrs: {
      "isMandatory": "",
      "idLabel": _vm.$t('businessDocuments.slct_sdr'),
      "hiddenLabel": true,
      "inputType": 'listeSelect',
      "mandatoryErrorIndicator": _vm.folderIdError
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.folderId),
      expression: "folderId"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "sel2",
      "readonly": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.folderId = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('creation_forms.slct_a_dr')))]), _vm._v(" "), _vm._l((_vm.jsonOfSharedFolders), function(value, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": index
      }
    }, [_vm._v("\n                  " + _vm._s(value) + "\n                ")])
  })], 2)])], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    staticClass: "form-group",
    attrs: {
      "sm": "6"
    }
  }, [_c('b-form-radio', {
    staticClass: "creationFormBtnRadio",
    attrs: {
      "name": "radios-sharedFolderType",
      "value": "2"
    },
    model: {
      value: (_vm.sharedFolderType),
      callback: function($$v) {
        _vm.sharedFolderType = $$v
      },
      expression: "sharedFolderType"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('businessDocuments.add_sdr')) + "\n            ")])], 1), _vm._v(" "), _c('b-col', {
    staticClass: "form-group",
    attrs: {
      "sm": "6"
    }
  }, [_c('form-write-group-label-input', {
    attrs: {
      "isMandatory": "",
      "idLabel": _vm.$t('businessDocuments.shared_folder_name'),
      "hiddenLabel": true,
      "placeholderValue": _vm.$t('businessDocuments.shared_folder_name'),
      "mandatoryErrorIndicator": _vm.folderNameError
    },
    model: {
      value: (_vm.folderName),
      callback: function($$v) {
        _vm.folderName = $$v
      },
      expression: "folderName"
    }
  })], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('hr'), _vm._v(" "), _c('form-accordion', {
    attrs: {
      "title": _vm.$t('common.add_msg')
    }
  }, [_c('b-row', [_c('b-col', {
    staticClass: "form-group"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formMessage),
      expression: "formMessage"
    }],
    staticClass: "form-control inputAccordionForm",
    staticStyle: {
      "margin-top": "4px"
    },
    attrs: {
      "placeholder": _vm.$t('common.general_msg')
    },
    domProps: {
      "value": (_vm.formMessage)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.formMessage = $event.target.value
      }
    }
  })])], 1)], 1)], 1), _vm._v(" "), _c('template', {
    slot: "footerButtons"
  }, [_c('b-row', {
    staticClass: "justify-content-start"
  }, [_c('b-col', {
    staticClass: "form-group",
    attrs: {
      "md": "3",
      "offset-md": "8"
    }
  }, [_c('f7-button', {
    staticClass: "button-action milkyBlockBlack",
    on: {
      "click": _vm.requestBusinessDocument
    }
  }, [_c('f7-icon', {
    attrs: {
      "fa": "paper-plane"
    }
  }), _vm._v("\n          " + _vm._s(_vm.$t('businessDocuments.form_document_request_button')) + "\n        ")], 1)], 1)], 1)], 1)], 2)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-e780e0e8", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e780e0e8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/requests/creationPages/RequestDocumentTemplate.vue
// module id = 2457
// module chunks = 2